import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowBackIcon',
  props: {
    fill: {
      type: String,
      default: 'white',
    },
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      fill: __props.fill,
      d: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
    }, null, 8, _hoisted_2)
  ]))
}
}

})